/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { NSBaseServer } from "namirasoft-site";
import { NamirasoftAPIProductServerCategory } from "./NamirasoftAPIProductServerCategory";
import { NamirasoftAPIProductServerFilter } from "./NamirasoftAPIProductServerFilter";
import { NamirasoftAPIProductServerHealthz } from "./NamirasoftAPIProductServerHealthz";
import { NamirasoftAPIProductServerInstance } from "./NamirasoftAPIProductServerInstance";
import { NamirasoftAPIProductServerOwner } from "./NamirasoftAPIProductServerOwner";
import { NamirasoftAPIProductServerProduct } from "./NamirasoftAPIProductServerProduct";
import { NamirasoftAPIProductServerStore } from "./NamirasoftAPIProductServerStore";

export class NamirasoftAPIProductServer extends NSBaseServer
{
    healthz: NamirasoftAPIProductServerHealthz;
    filter: NamirasoftAPIProductServerFilter;
    product: NamirasoftAPIProductServerProduct;
    category: NamirasoftAPIProductServerCategory;
    owner: NamirasoftAPIProductServerOwner;
    store: NamirasoftAPIProductServerStore;
    instance: NamirasoftAPIProductServerInstance;
    protected onError;
    constructor(base_url: string, onError: (error: Error) => void)
    {
        super(base_url, `1.4.25`);
        this.onError = onError;
        this.healthz = new NamirasoftAPIProductServerHealthz(this);
        this.filter = new NamirasoftAPIProductServerFilter(this);
        this.product = new NamirasoftAPIProductServerProduct(this);
        this.category = new NamirasoftAPIProductServerCategory(this);
        this.owner = new NamirasoftAPIProductServerOwner(this);
        this.store = new NamirasoftAPIProductServerStore(this);
        this.instance = new NamirasoftAPIProductServerInstance(this);
    }
};